import {Image} from '@yandex-delivery/blocks/image'
import {tag2url} from '@yandex-delivery/utils'
import React, {memo} from 'react'

import {IconSpotWidgetConfig} from '../types'
import * as classes from './IconSpot.classes'

export const IconSpotWidget = memo(({icon_spot}: IconSpotWidgetConfig): React.ReactElement => {
  return (
    <div
      className={classes.iconSpotWrapper}
      style={icon_spot.background_color ? {backgroundColor: icon_spot.background_color} : {}}
    >
      <Image height={24} src={tag2url(icon_spot.icon.image_tag)} />
    </div>
  )
})
